module.exports = __webpack_public_path__ + "img/laptop.1d31ab02.svg";